import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';
import {UserpermissionService} from '../../services/userpermission.service';
import{ArticleService} from '../../services/article.service';
import {UserService} from '../../services/user.service';
import {NewsletterService} from '../../services/newsletter.service';



declare var $:any;
import * as moment from 'moment';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.css']
})
export class AnalyticsComponent implements OnInit,IRule  {

  @HostBinding('style.width') public width: string = '100%';

  userName='';
  navigationsType=[];
  notification:any=[];
  msg:any;
	toastr:any;
  _router:any;
  token:any='';
  msgSubscribe:Subscription;
  loader_image:boolean =true;

  startDate:any;
  endDate:any;
  dropdownSettings = {};
  newsletterList = [];
  selectedNewsletter = [];
  articleList = [];
  selectedArticle = [];
  emailList = [];
  selecteEmail = [];
  userList = [];
  selectedUser = [];
  countryList=[];
  country= [
    {key:'Australia',value:'Australia'},
    {key:'Austria',value:'Austria'},
    {key:'Bahrain',value:'Bahrain'},
    {key:'Belgium',value:'Belgium'},
    {key:'Bosnia & Herzegovina',value:'Bosnia & Herzegovina'},
    {key:'Bulgaria',value:'Bulgaria'},
    {key:'Canada',value:'Canada'},
    {key:'Croatia',value:'Croatia'},
    {key:'Cyprus',value:'Cyprus'},
    {key:'Czech Republic',value:'Czech Republic'},
    {key:'Denmark',value:'Denmark'},
    {key:'Estonia',value:'Estonia'},
    {key:'Finland',value:'Finland'},
    {key:'France',value:'France'},
    {key:'Germany',value:'Germany'},
    {key:'Greece',value:'Greece'},
    {key:'Hungary',value:'Hungary'},
    {key:'Iceland',value:'Iceland'},
    {key:'India',value:'India'},
    {key:'Ireland',value:'Ireland'},
    {key:'Israel',value:'Israel'},
    {key:'Italy',value:'Italy'},
    {key:'Japan',value:'Japan'},
    {key:'Latvia',value:'Latvia'},
    {key:'Lithuania',value:'Lithuania'},
    {key:'Luxembourg',value:'Luxembourg'},
    {key:'Macedonia',value:'Macedonia'},
    {key:'Malaysia',value:'Malaysia'},
    {key:'Malta',value:'Malta'},
    {key:'Moldova',value:'Moldova'},
    {key:'Netherlands',value:'Netherlands'},
    {key:'New Zealand',value:'New Zealand'},
    {key:'Norway',value:'Norway'},
    {key:'Palestine',value:'Palestine'},
    {key:'Phillipines',value:'Phillipines'},
    {key:'Poland',value:'Poland'},
    {key:'Portugal',value:'Portugal'},
    {key:'Qatar',value:'Qatar'},
    {key:'Montenegro',value:'Montenegro'},
    {key:'Serbia',value:'Serbia'},
    {key:'Romania',value:'Romania'},
    {key:'Russia',value:'Russia'},
    {key:'Saudi Arabia',value:'Saudi Arabia'},
    {key:'Slovakia',value:'Slovakia'},
    {key:'Slovenia',value:'Slovenia'},
    {key:'South Africa',value:'South Africa'},
    {key:'Spain',value:'Spain'},
    {key:'Sweden',value:'Sweden'},
    {key:'Switzerland',value:'Switzerland'},
    {key:'Thailand',value:'Thailand'},
    {key:'Turkey',value:'Turkey'},
    {key:'Ukraine',value:'Ukraine'},
    {key:'United Arab Erimates',value:'United Arab Erimates'},
    {key:'United Kingdom',value:'UK'},
    {key:'United States of America',value:'United States of America'}
    
    ];
    
  selectedCountry = [];

  count:number=10;
  newsSentOn:boolean=true;
  newsSentTo:boolean=true;
  newsReceived:boolean=true;
  newsBounced:boolean=true;
  newsClicked:boolean=true;
  newsLogged:boolean=true;
  newsLeft:boolean=true;
  newsDeliveryRate:boolean=false;
  newsOpenRate:boolean=false;
  newsClickRate:boolean=false;
  newsConversionRate:boolean=false;
  newsROI:boolean=false;
  newsComplaint:boolean=false;
  newsContactList:boolean=false;
  newsUnsubscribed:boolean=false;
  newsSource:boolean=false;
  newsProtal:boolean=false;
  
  articleSentTo:boolean=true;
  articleName:boolean=true;
  articleClicked:boolean=true;
  articleViewed:boolean=true;
  articleComments:boolean=false;
  articleDownload:boolean=true;
  articleAttached:boolean=false;

  userEmail:boolean=true;
  userCountry:boolean=true;
  userNewsletter:boolean=true;
  userArticle:boolean=true;
  userClicked:boolean=true;
  userLogin:boolean=true;
  userLeft:boolean=true;
  userComments:boolean=false;
  userSession:boolean=false;
  userReturned:boolean=false;

  newsletterReportList:any=[];
  articleReportList:any=[];
  userReportList:any=[];

  articleViewHistoryName:any
  articleViewHistoryList:any=[]
  articleViewHistoryCol:any

  userArticleViewHistoryName:any
  userArticleViewHistoryList:any=[]
  userArticleViewHistoryCol:any


  userLoogedName:any
  userLoogedList:any=[]
  userLoogedColName:any;

  newsshow1:boolean=true
  newsshow2:boolean=true
  newsshow3:boolean=true
  newsshow4:boolean=true
  newsshow5:boolean=true
  newsshow6:boolean=true
  newsshow7:boolean=true
  newsshow8:boolean=true
  newsshow9:boolean=true
  newsshow10:boolean=true
  newsshow11:boolean=true
  newsshow12:boolean=true
  newsshow13:boolean=true
  newsshow14:boolean=true
  newsshow15:boolean=true
  newsshow16:boolean=true

  newsshowup1:boolean=false
  newsshowup2:boolean=false
  newsshowup3:boolean=false
  newsshowup4:boolean=false
  newsshowup5:boolean=false
  newsshowup6:boolean=false
  newsshowup7:boolean=false
  newsshowup8:boolean=false
  newsshowup9:boolean=false
  newsshowup10:boolean=false
  newsshowup11:boolean=false
  newsshowup12:boolean=false
  newsshowup13:boolean=false
  newsshowup14:boolean=false
  newsshowup15:boolean=false
  newsshowup16:boolean=false

  newsshowdn1:boolean=false
  newsshowdn2:boolean=false
  newsshowdn3:boolean=false
  newsshowdn4:boolean=false
  newsshowdn5:boolean=false
  newsshowdn6:boolean=false
  newsshowdn7:boolean=false
  newsshowdn8:boolean=false
  newsshowdn9:boolean=false
  newsshowdn10:boolean=false
  newsshowdn11:boolean=false
  newsshowdn12:boolean=false
  newsshowdn13:boolean=false
  newsshowdn14:boolean=false
  newsshowdn15:boolean=false
  newsshowdn16:boolean=false

  isAscending:boolean=true
  isAscendingNewsName:boolean=true
  isAscendingNewsDel:boolean=true
  isAscendingNewsSend:boolean=true
  isAscendingNewsReceived:boolean=true
  isAscendingNewsBounced:boolean=true
  isAscendingNewsClicked:boolean=true
  isAscendingNewsLogged:boolean=true
  isAscendingNewsLeft:boolean=true
  isAscendingNewsOpen:boolean=true
  isAscendingNewsClickRate:boolean=true
  isAscendingNewsConversionRate:boolean=true
  isAscendingNewsROI:boolean=true
  isAscendingNewsComplaint:boolean=true
  isAscendingNewsContactList:boolean=true
  isAscendingNewsUnsubscribed:boolean=true

  artshow1:boolean=true
  artshow2:boolean=true
  artshow3:boolean=true
  artshow4:boolean=true
  artshow5:boolean=true
  artshow6:boolean=true
  artshow7:boolean=true
  artshow8:boolean=true

  artshowup1:boolean=false
  artshowup2:boolean=false
  artshowup3:boolean=false
  artshowup4:boolean=false
  artshowup5:boolean=false
  artshowup6:boolean=false
  artshowup7:boolean=false
  artshowup8:boolean=false

  artshowdn1:boolean=false
  artshowdn2:boolean=false
  artshowdn3:boolean=false
  artshowdn4:boolean=false
  artshowdn5:boolean=false
  artshowdn6:boolean=false
  artshowdn7:boolean=false
  artshowdn8:boolean=false

  isAscendinArtName:boolean=true
  isAscendinArtNews:boolean=true
  isArticleAscending:boolean=true
  isAscendinArtClicked:boolean=true
  isAscendinArtViewed:boolean=true
  isAscendinArtComments:boolean=true
  isAscendinArtDocument:boolean=true
  isAscendinArtAttached:boolean=true

  usershow1:boolean=true
  usershow2:boolean=true
  usershow3:boolean=true
  usershow4:boolean=true
  usershow5:boolean=true
  usershow6:boolean=true
  usershow7:boolean=true
  usershow8:boolean=true
  usershow9:boolean=true
  usershow10:boolean=true

  usershowup1:boolean=false
  usershowup2:boolean=false
  usershowup3:boolean=false
  usershowup4:boolean=false
  usershowup5:boolean=false
  usershowup6:boolean=false
  usershowup7:boolean=false
  usershowup8:boolean=false
  usershowup9:boolean=false
  usershowup10:boolean=false

  usershowdn1:boolean=false
  usershowdn2:boolean=false
  usershowdn3:boolean=false
  usershowdn4:boolean=false
  usershowdn5:boolean=false
  usershowdn6:boolean=false
  usershowdn7:boolean=false
  usershowdn8:boolean=false
  usershowdn9:boolean=false
  usershowdn10:boolean=false

  isAscendinUserName:boolean=true
  isAscendinUserEmail:boolean=true
  isAscendinUserNews:boolean=true
  isAscendinUserArts:boolean=true
  isAscendinUserClicked:boolean=true
  isAscendinUserLogged:boolean=true
  isAscendinUserLeft:boolean=true
  isAscendinUserComments:boolean=true
  isAscendinUserSessions:boolean=true
  isAscendinUserCountry:boolean=true


  constructor(private _activatedRoute: ActivatedRoute,msg:MessageService, toastr: ToastrService, _router: Router,private articleService:ArticleService,private userService:UserService,private userpermissionService:UserpermissionService,private newsService:NewsletterService) { 
  	this.msg = msg;
    this.toastr = toastr;
    this._router =_router;

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);
      this.token = tokenA.token;
      let data1={
        token:tokenA.token,
        newsletter:'sent'
      }
      let data2={
        token:tokenA.token,
        article:'published'
      }
      let data3={
        token:tokenA.token,
        user:"user|\\[\\]"
      }
      this.groupList(data1,data2,data3);

    }catch(error){

      this._router.navigate(['/vlogin']);

    }


   }

   
  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // let arr=[]
    // this.country.map((x)=>{
    //   let obj={}
    //   obj['key']=x.key.toUpperCase()
    //   obj['value']= x.value
    //   arr.push(obj)
    // })
    // this.countryList=arr

    this.fetchReport()

   

    
    // let t1='12'
    // let time2= moment(t1, 'HH:mm').add(30, 'minutes').format('HH:mm');
    // let time3= moment(time2, 'HH:mm').add(30, 'minutes').format('HH:mm');
    // let timeSlot=[]
    // timeSlot.push('00:00 AM')
    // for(let i=1;i<48;i++){
    //   let time = moment(timeSlot[i-1], ["h:mm A"]).add(30,'minutes').format("hh:mm A");
    //   timeSlot.push(time)
    // }
    // let slots =[]
    // timeSlot.map((x)=>{
      
    //     slots.push(x)
      
    // })
    
  }
 

  ngAfterViewInit(): void {

    $(document).ready(function() {


      $('input').blur(function(event) {
          var inputValue = this.value;
          if (inputValue) {
              this.classList.add('value-exists');
          } else {
              this.classList.remove('value-exists');
          }
      });


      //Right Select Column
      $("#show_column").click(function(event) { 
          event.stopPropagation();
          $("#column_sidebar").addClass("menu-open");
          $('body').addClass('overflow-hidden');
         
      });
      $("#column_sidebar").click(function(event) {
          event.stopPropagation();
      });
      $("#msg-box-close").click(function() {
          $("#column_sidebar").removeClass("menu-open");
          $('body').removeClass('overflow-hidden');
      });
      $('body').click(function() {
          $("#column_sidebar").removeClass("menu-open");
          //$(".main-menu").removeClass("mob-menu-bg");
          $('body').removeClass('overflow-hidden');
      });

      //Filter slide
      $("#filter_button").click(function() {
          $(".report-panel-box").toggleClass("filter-open");
          $(".report-filter-box").toggleClass("show");
          $(".show-hide").toggleClass("show");
          var reportFilterHeight = $('body').innerHeight();
          if($(".report-panel-box").hasClass("filter-open")){
              $(".report-panel-box").css("min-height", reportFilterHeight);
          }else{
              $(".report-panel-box").css("min-height", "1px");
          }

      });

      // $('#start_date .date').datepicker({
      //     format: 'yyyy-mm-dd',
      //     autoclose: true,
      // }).on('changeDate', function(e) {
      //   this.startdate=e.format()
      //   $('#start_date').addClass('value-exists')
        
      // }.bind(this));

      // $('#end_date .date').datepicker({
      //   format: 'yyyy-mm-dd',
      //   autoclose: true,
      // }).on('changeDate', function(e) {
      //   this.enddate=e.format()
      //   console.log('hhhhh',this.enddate,this.startdate)
      //   $('#end_date').addClass('value-exists')
       
      // }.bind(this));

      $('.datepicker1').datepicker({
        
        autoclose: true,
        format: "yyyy-mm-dd",
       
      }).on('changeDate', function(e) {

            this.startDate =e.format();
            
            $('.datepicker1').addClass('value-exists')

            $('.datepicker1').datepicker('update');

      }.bind(this));

      $('input').not('.datepicker1').blur(function(event) {
        var inputValue = this.value;
        if (inputValue) {
          this.classList.add('value-exists');
        } else {
          this.classList.remove('value-exists');
        }
      });

      $('.datepicker2').datepicker({
        
        autoclose: true,
        format: "yyyy-mm-dd",
       
      }).on('changeDate', function(e) {

            this.endDate =e.format();

            $('.datepicker2').addClass('value-exists')

            $('.datepicker2').datepicker('update');

      }.bind(this));

      $('input').not('.datepicker2').blur(function(event) {
        var inputValue = this.value;
        if (inputValue) {
          this.classList.add('value-exists');
        } else {
          this.classList.remove('value-exists');
        }
      });


    })
  }

  groupList(data1,data2,data3){

    this.newsService.newsletterList(data1).subscribe( (response)=>{

      let list =[]

      if(response.status=='success' ){

        this.userName=response.user.name;

        this.navigationsType=response.navigation;

        this.notification =response.notification;

        this.broadcast_menu();

        if(response.newsletter!=undefined ){
          response.newsletter.map((x)=>{
            let data={}
            data['key']= x.id;
            data['value'] = x.templateName;

            list.push(data)
          })

          this.newsletterList = list;

        }
      }
    })


    this.articleService.articleData(data2).subscribe( (result)=>{

      if(result.status=='success' ){

        let list =[]
        if(result.article!=undefined){
          result.article.map((x)=>{
            let data={}
            data['key']= x.id;
            data['value'] = x.title;
  
            list.push(data)
          })
  
          this.articleList = list;
        }
       
      }
     
    })

   
    this.newsService.getUserList(data3).subscribe( (response)=>{

      let list =[],listemail=[] , arr=[]

      if(response.status=='success' ){

        if(response.users!=undefined ){
          
          response.users.map((x)=>{
            let data={},obj={},cnt={}
            data['key']= x.email.toUpperCase();
            data['value'] = x.name;
            obj['key']= x.email.toUpperCase();
            obj['value'] = x.email;

            if(x.country!=null){
              cnt['key']=x.country.toUpperCase()
              cnt['value']= x.country
              arr.push(cnt)
            }

            list.push(data)
            listemail.push(obj)
          })

          this.userList = list;
          this.emailList = listemail
          var flags = [], output = [], l = arr.length, i;
          for( i=0; i<l; i++) {
              if(flags[arr[i].key]) continue;
              flags[arr[i].key] = true;
              output.push(arr[i]);
          }
          this.countryList=output
   
    
  

        }
      }
    })

  }

  broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
  }

  onNewsSelect(item: any) {
    
  }

  onNewsSelectAll(items: any) {
    
  }

  onNewsDeSelect(event:any){
   
  }

  onNewsDeSelectAll(event:any){

  }

  removeNewsletter(event,key,i,list){

    let arr = []
    let index = list.findIndex(x => x.key ==key);
    list.splice(index, 1);

    list.map((x)=>{
      let data={}
      data['key']= x.key;
      data['value'] = x.value;
      arr.push(data)
    })
    this.selectedNewsletter= arr
   
  }

  onArticleSelect($event){

  }

  onArticleSelectAll($event){

  }

  onArticleDeSelect($event){

  }

  onArticleDeSelectAll($event){

  }

  removeArticle(event,key,i,list){

    let arr = []
    let index = list.findIndex(x => x.key ==key);
    list.splice(index, 1);

    list.map((x)=>{
      let data={}
      data['key']= x.key;
      data['value'] = x.value;
      arr.push(data)
    })
    this.selectedArticle= arr
   
  }

  onEmailSelect($event){

  }

  onEmailSelectAll($event){

  }

  onEmailDeSelect($event){

  }

  onEmailDeSelectAll($event){

  }

  removeEmail(event,key,i,list){

    let arr = []
    let index = list.findIndex(x => x.key ==key);
    list.splice(index, 1);

    list.map((x)=>{
      let data={}
      data['key']= x.key;
      data['value'] = x.value;
      arr.push(data)
    })
    this.selecteEmail= arr
   
  }

  onUserSelect($event){

  }

  onUserSelectAll($event){

  }

  onUserDeSelect($event){

  }

  onUserDeSelectAll($event){

  }

  removeUser(event,key,i,list){

    let arr = []
    let index = list.findIndex(x => x.key ==key);
    list.splice(index, 1);

    list.map((x)=>{
      let data={}
      data['key']= x.key;
      data['value'] = x.value;
      arr.push(data)
    })
    this.selectedUser= arr
   
  }

  onCountrySelect($event){

  }

  onCountrySelectAll($event){

  }

  onCountryDeSelect($event){

  }

  onCountryDeSelectAll($event){

  }

  removeCountry(event,key,i,list){

    let arr = []
    let index = list.findIndex(x => x.key ==key);
    list.splice(index, 1);

    list.map((x)=>{
      let data={}
      data['key']= x.key;
      data['value'] = x.value;
      arr.push(data)
    })
    this.selectedCountry= arr
   
  }


  fetchReport(){

    this.loader_image=true
    //Set
   // $('#txt_name').val(bla);
    var start = $('#start_name').val();
    var end = $('#end_name').val();
    
    let data={
      from:start,
      to:end
    }
    let newsletter=[],article=[],user=[],country=[]

    if(this.selectedNewsletter.length>0){
      this.selectedNewsletter.map((x)=>{
        newsletter.push(x.key)
      })
    }
    data['newsletter']=newsletter

    if(this.selectedArticle.length>0){
      this.selectedArticle.map((x)=>{
        article.push(x.key)
      })
    }
    data['article']=article

    if(this.selecteEmail.length>0){
      this.selecteEmail.map((x)=>{
        user.push(x.key)
      })
    }
    if(this.selectedUser.length>0){
      this.selectedUser.map((x)=>{
        user.push(x.key)
      })
    }
    data['user']=user

    if(this.selectedCountry.length>0){
      this.selectedCountry.map((x)=>{
        country.push(x.key)
      })
    }
    data['country']=country
    data['token']=this.token
    data['page']='analytics'
   
    if(end && start && end<start){
      this.toastr.error('End date should be greater than start date', '', {timeOut: 3000});
      this.loader_image=false
    }else{
     
      this.newsletterReportList=[];
      this.articleReportList=[];
      this.userReportList=[];
      
       this.articleService.analytics(data).subscribe( (res)=>{

        if(res.status=='success' ){
          this.loader_image=false
          let newsArr=[],artArr=[],userArr=[]
          if(res.newsletters!=undefined){
            res.newsletters.map((x)=>{

              if(x.name!=undefined && x.name!=null && x.newsletter.processed!=undefined){  
                let newsobj={}
                newsobj['id']=x.id
                newsobj['name']=x['name']
                newsobj['sent_Date']=x['date']
                newsobj['sent_To']=x.newsletter.processed
                newsobj['received']=x.newsletter.delivered
                newsobj['bounced']=x.newsletter.bounce
                newsobj['clicked']=x.newsletter.click
                newsobj['logged_In']=x.newsletter.view
               
  
                let left = x.newsletter.click - x.newsletter.view
                let val =0
                if(left>0){
                  val=left
                }
                newsobj['left']=val
  
                let drate = (x.newsletter.delivered/x.newsletter.processed)*100;
                let dval = (isNaN(drate))?0:Math.round(drate);
                newsobj['delivery_Rate']=dval
  
                let oprate = (x.newsletter.open /x.newsletter.delivered)*100
                let opval = (isNaN(oprate))?0:Math.round(oprate);
                newsobj['open_Rate']=opval
  
                let crate = (x.newsletter.click /x.newsletter.delivered)*100
                let cval=(isNaN(crate))?0:Math.round(crate);
                newsobj['click_Rate']=cval
  
  
                let conrate = (x.newsletter.view /x.newsletter.click)*100
                let coval=(isNaN(conrate))?0:Math.round(conrate);
                newsobj['conversion_Rate']=coval

                let roi = (x.newsletter.view /x.newsletter.delivered)*100
                let roval=(isNaN(roi))?0:Math.round(roi);
                newsobj['roi']=roval
                
                newsobj['spam_Complaint']=x.newsletter.spam
                
                let clist = (x.newsletter.view /x.newsletter.processed)*100
                let clistval=(isNaN(clist))?0:Math.round(clist);
                newsobj['contact_List_Performance']=clistval

                newsobj['unsubscribed']=x.newsletter.unsubscribe

  
                newsArr.push(newsobj)
              }
              
  
            })
            this.newsletterReportList=newsArr;
          }

          if(res.articles!=undefined){
            
            res.articles.map((x)=>{
              if(x.name!=undefined && x.name!=null){
                let artsobj={}
                artsobj['id']=x.id
                artsobj['name']=x['name']
                artsobj['newsletter']=x.newsletter
                artsobj['sent_On']=x['date']
                artsobj['viewed']=x.article.view
                artsobj['clicked']=x.article.click
                artsobj['comments']=x.article.comment
                artsobj['document_Download']=x.article.download
                artsobj['attached_Document']=x.article.attachment
               

                artArr.push(artsobj)
              }
              
            })
            this.articleReportList=artArr;
          }

          if(res.users!=undefined){

            res.users.map((x)=>{
              if(x.event!=undefined && x.event!=null && x.email!=undefined){
                let usersobj={}
                usersobj['id']=x.id
                usersobj['name']=x['name']
                usersobj['email']=x['email']

                if( x.event && x.event.newsletter!=undefined){
                  usersobj['newsletters']=x.event.newsletter
                }else{
                  usersobj['newsletters']='' 
                }

                if(x.event && x.event.article!=undefined){
                  usersobj['article']=x.event.article
                }else{
                  usersobj['article']=''
                }
               
                
                usersobj['clicked']=x.user.click
                usersobj['logged_in']=x.user.view
                
                let left = x.user.click - x.user.view
                let val =0
                if(left>0){
                  val=left
                }
                usersobj['left']=val
                usersobj['comments']=x.user.comment
                usersobj['country']=x['country']

                let ss;

                if(x.user.login>x.user.logout){
                  ss=x.user.login
                }else if(x.user.login<x.user.logout){
                  ss=x.user.logout
                }else{
                  ss=x.user.view
                }
                
                usersobj['sessions']=ss

                userArr.push(usersobj)
              }
              
            })
            this.userReportList=userArr;
           
          }
         
        }else{
          this.loader_image=false
          console.log('err',res)
        }
       })
    }
  }

  clear(){

    var start = '';
    $('#start_name').val(start);
    var end = ''
    $('#end_name').val(end);
    this.selectedNewsletter=[];
    this.selectedArticle=[];
    this.selecteEmail=[];
    this.selectedUser=[];
    this.selectedCountry=[];

    $('#start_name').removeClass('value-exists')
    $('#end_name').removeClass('value-exists')
   
    
  }

  onNewsChange(event,indx){
    
    let len = $('.newsletter-checkboxes input:checked').length
    if(len<8){
      $('.newsletter-checkboxes input:not(:checked)').prop('disabled',false)
     
      if(indx==1){
       this.newsSentOn=event
      }else if(indx==2){
       this.newsSentTo=event
      }else if(indx==3){
        this.newsReceived=event
      }else if(indx==4){
        this.newsBounced=event
      }else if(indx==5){
        this.newsClicked=event
      }else if(indx==6){
        this.newsLogged=event
      }else if(indx==7){
        this.newsLeft=event
      }else if(indx==8){
        this.newsDeliveryRate=event
      }else if(indx==9){
        this.newsOpenRate=event
      }else if(indx==10){
        this.newsClickRate=event
      }else if(indx==11){
        this.newsConversionRate=event
      }else if(indx==12){
        this.newsROI=event
      }else if(indx==13){
        this.newsComplaint=event
      }else if(indx==14){
        this.newsContactList=event
      }else if(indx==15){
        this.newsUnsubscribed=event
      }else if(indx==16){
        this.newsSource=event
      }else if(indx==17){
        this.newsProtal=event
      }


    }else{
      $('.newsletter-checkboxes input:not(:checked)').prop('disabled',true)
      // this.toastr.error('Maximum 10 columns allow', '', {timeOut: 3000});
     }
    
    
  }



  onArticleSentToChange(event){
    this.articleSentTo=event
  }
  onArticleNameChange(event){
    this.articleName=event
  }
  onArticleClickedChange(event){
    this.articleClicked=event
  }
  onArticleViewedChange(event){
    this.articleViewed=event
  }
  onArticleCommentsChange(event){
    this.articleComments=event
  }
  onArticleDownloadChange(event){
    this.articleDownload=event
  }

  onArticleAttachedChange(event){
    this.articleAttached=event
  }


  onUserEmailChange(event){
    this.userEmail=event
  }
  onUserCountryChange(event){
    this.userCountry=event
  }
  onUserNewsletterChange(event){
    this.userNewsletter=event
  }
  onUserArticleChange(event){
    this.userArticle=event
  }
  onUserClickedChange(event){
    this.userClicked=event
  }
  onUserLoginChange(event){
    this.userLogin=event
  }
  onUserLeftChange(event){
   this.userLeft=event
  }
  onUserCommentsChange(event){
   this.userComments=event
  }
  onUserSessionChange(event){
    this.userSession=event
  }
  onUserReturnedChange(event){
    this.userReturned=event
  }

  articleView(id,col,name,event,type){
    
      this.loader_image=true
      this.articleViewHistoryName=name
      this.articleViewHistoryCol=col
      
      let data={}
      data['token']=this.token
      data['page']='analytics'
      if(type=='Article'){
        data['article']=[id.toString()]
      }else{
        data['newsletter']=[id.toString()]
      }
      
      data['column']=col
      data['event']=[event.toString()]

      this.articleViewHistoryList=[]
   
       this.articleService.analytics(data).subscribe( (res)=>{

        if(res.status=='success' ){
          this.loader_image=false
          if(res.users!=undefined){
            this.articleViewHistoryList=res.users
          }
        }else{
          this.loader_image=false
          console.log('err',res)
        }
       })
    
  }

  userArticleView(id,col,name,event){

      this.userArticleViewHistoryName=name
      this.userArticleViewHistoryCol=col
      this.loader_image=true
      
      let data={}
      data['token']=this.token
      data['page']='analytics'
      data['user']=[id.toString()]
      data['column']=col
      data['event']=[event.toString()]

      this.userArticleViewHistoryList=[]
   
       this.articleService.analytics(data).subscribe( (res)=>{

        if(res.status=='success' ){
          this.loader_image=false

          if(col=='Article View'){
            if(res.articles!=undefined){
              this.userArticleViewHistoryList=res.articles
             }
          }
        
         if(col=='Newsletter View'){
          if(res.articles!=undefined){
            this.userArticleViewHistoryList=res.newsletters
           }
         }

        }else{
          this.loader_image=false
          console.log('err',res)
        }
       })
  }

  userLooged(id,col,name,event){

      this.userLoogedColName=col
      this.userLoogedName=name
      this.loader_image=true
     
      let data={}
      data['token']=this.token
      data['page']='analytics'
      data['user']=[id.toString()]
      data['column']=col
      data['event']=[event.toString()]
   
       this.articleService.analytics(data).subscribe( (res)=>{

        if(res.status=='success' ){
          this.loader_image=false
          let logArr=[]
          if(res.users!=undefined){
            res.users[0].user.map((x)=>{
              let val=x.split("at")
              let obj={}
              obj['date']=val[0]
              obj['time']=val[1]
              logArr.push(obj)
            })
            this.userLoogedList=logArr
          }
        }else{
          this.loader_image=false
          console.log('err',res)
        }
       })
  }

  exportAsXLSX():void {

    let arr=[],arr2=[],arr3=[]
     this.newsletterReportList.map((x)=>{
      delete x.id;
      let y = Object.keys(x).reduce(function(accum, key) {
        accum[key.toUpperCase()] = x[key];
        return accum;
      }, {})
      arr.push(y)
    })
    this.articleReportList.map((x)=>{
      delete x.id;
      let y = Object.keys(x).reduce(function(accum, key) {
        accum[key.toUpperCase()] = x[key];
        return accum;
      }, {})
      arr2.push(y)
    })
    this.userReportList.map((x)=>{
      delete x.id;
      let y = Object.keys(x).reduce(function(accum, key) {
        accum[key.toUpperCase()] = x[key];
        return accum;
      }, {})
      arr3.push(y)
    })
    
    this.articleService.exportAsExcelFile(arr, 'Newsletters');
    this.articleService.exportAsExcelFile(arr2, 'Articles');
    this.articleService.exportAsExcelFile(arr3, 'Users');

  }

  sortArray(arrval, isAscending) {

   
    this.newsshow1=true
    // this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscending;
    let arr = arrval.filter(city => city.sent_Date!=null);

    if(currentSort){
      this.newsshow2=false
      this.newsshowup2=false
      this.newsshowdn2=true
      arr.sort(function(a, b){
        var aa = a.sent_Date.split('/').reverse().join(),
            bb = b.sent_Date.split('/').reverse().join();
        return aa < bb ? -1 : (aa > bb ? 1 : 0);
      });
      
    }else{
      this.newsshow2=false
      this.newsshowup2=true
      this.newsshowdn2=false
      arr.sort(function(b, a){
        var aa = a.sent_Date.split('/').reverse().join(),
            bb = b.sent_Date.split('/').reverse().join();
        return aa < bb ? -1 : (aa > bb ? 1 : 0);
      });
      
    }

    this.newsletterReportList=arr
    
    this.isAscending = isAscending ? false : true;
  }

  sortNewsName(arrval, isAscending) {

    // this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsName;
    let arr = arrval.filter(city => city.name!=null);

    if(currentSort){
      this.newsshow1=false
      this.newsshowup1=false
      this.newsshowdn1=true
      arr.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow1=false
      this.newsshowup1=true
      this.newsshowdn1=false
      arr.sort((b,a) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsName = isAscending ? false : true;
  }

  sortNewsDel(arrval, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    // this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsDel;
    let arr = arrval.filter(city => city.delivery_Rate!=null);

    if(currentSort){
      this.newsshow9=false
      this.newsshowup9=false
      this.newsshowdn9=true
      arr.sort((a,b) => (a.delivery_Rate > b.delivery_Rate) ? 1 : ((b.delivery_Rate > a.delivery_Rate) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow9=false
      this.newsshowup9=true
      this.newsshowdn9=false
      arr.sort((b,a) => (a.delivery_Rate > b.delivery_Rate) ? 1 : ((b.delivery_Rate > a.delivery_Rate) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsDel = isAscending ? false : true;
  }

  sortNewsSend(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    // this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsSend;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.sent_To==undefined || x.sent_To==null){
        x.sent_To=''
      }
    })

    if(currentSort){
      this.newsshow3=false
      this.newsshowup3=false
      this.newsshowdn3=true
      arr.sort((a,b) => (a.sent_To > b.sent_To) ? 1 : ((b.sent_To > a.sent_To) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow3=false
      this.newsshowup3=true
      this.newsshowdn3=false
      arr.sort((b,a) => (a.sent_To > b.sent_To) ? 1 : ((b.sent_To > a.sent_To) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsSend = isAscending ? false : true;
  }

  sortNewsReceived(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    // this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsReceived;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.received==undefined || x.received==null){
        x.received=''
      }
    })

    if(currentSort){
      this.newsshow4=false
      this.newsshowup4=false
      this.newsshowdn4=true
      arr.sort((a,b) => (a.received > b.received) ? 1 : ((b.received > a.received) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow4=false
      this.newsshowup4=true
      this.newsshowdn4=false
      arr.sort((b,a) => (a.received > b.received) ? 1 : ((b.received > a.received) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsReceived = isAscending ? false : true;
  }

  sortNewsBounced(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    //this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsBounced;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.bounced==undefined || x.bounced==null){
        x.bounced=''
      }
    })

    if(currentSort){
      this.newsshow5=false
      this.newsshowup5=false
      this.newsshowdn5=true
      arr.sort((a,b) => (a.bounced > b.bounced) ? 1 : ((b.bounced > a.bounced) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow5=false
      this.newsshowup5=true
      this.newsshowdn5=false
      arr.sort((b,a) => (a.bounced > b.bounced) ? 1 : ((b.bounced > a.bounced) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsBounced = isAscending ? false : true;
  }

  sortNewsClicked(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    // this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsClicked;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.clicked==undefined || x.clicked==null){
        x.clicked=''
      }
    })

    if(currentSort){
      this.newsshow6=false
      this.newsshowup6=false
      this.newsshowdn6=true
      arr.sort((a,b) => (a.clicked > b.clicked) ? 1 : ((b.clicked > a.clicked) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow6=false
      this.newsshowup6=true
      this.newsshowdn6=false
      arr.sort((b,a) => (a.clicked > b.clicked) ? 1 : ((b.clicked > a.clicked) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsClicked = isAscending ? false : true;
  }

  sortNewsLogged(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    // this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsLogged;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.clicked==undefined || x.clicked==null){
        x.clicked=''
      }
    })

    if(currentSort){
      this.newsshow7=false
      this.newsshowup7=false
      this.newsshowdn7=true
      arr.sort((a,b) => (a.logged_In > b.logged_In) ? 1 : ((b.logged_In > a.logged_In) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow7=false
      this.newsshowup7=true
      this.newsshowdn7=false
      arr.sort((b,a) => (a.logged_In > b.logged_In) ? 1 : ((b.logged_In > a.logged_In) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsLogged = isAscending ? false : true;
  }

  sortNewsLeft(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    // this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsLeft;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.left==undefined || x.left==null){
        x.left=''
      }
    })

    if(currentSort){
      this.newsshow8=false
      this.newsshowup8=false
      this.newsshowdn8=true
      arr.sort((a,b) => (a.left > b.left) ? 1 : ((b.left > a.left) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow8=false
      this.newsshowup8=true
      this.newsshowdn8=false
      arr.sort((b,a) => (a.left > b.left) ? 1 : ((b.left > a.left) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsLeft = isAscending ? false : true;
  }

  sortNewsOpen(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    // this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsOpen;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.open_Rate==undefined || x.open_Rate==null){
        x.open_Rate=''
      }
    })

    if(currentSort){
      this.newsshow10=false
      this.newsshowup10=false
      this.newsshowdn10=true
      arr.sort((a,b) => (a.open_Rate > b.open_Rate) ? 1 : ((b.open_Rate > a.open_Rate) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow10=false
      this.newsshowup10=true
      this.newsshowdn10=false
      arr.sort((b,a) => (a.open_Rate > b.open_Rate) ? 1 : ((b.open_Rate > a.open_Rate) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsOpen = isAscending ? false : true;
  }

  sortNewsClickRate(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    // this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsClickRate;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.click_Rate==undefined || x.click_Rate==null){
        x.click_Rate=''
      }
    })

    if(currentSort){
      this.newsshow11=false
      this.newsshowup11=false
      this.newsshowdn11=true
      arr.sort((a,b) => (a.click_Rate > b.click_Rate) ? 1 : ((b.click_Rate > a.click_Rate) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow11=false
      this.newsshowup11=true
      this.newsshowdn11=false
      arr.sort((b,a) => (a.click_Rate > b.click_Rate) ? 1 : ((b.click_Rate > a.click_Rate) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsClickRate = isAscending ? false : true;
  }

  sortNewsConversionRate(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    // this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsConversionRate;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.conversion_Rate==undefined || x.conversion_Rate==null){
        x.conversion_Rate=''
      }
    })

    if(currentSort){
      this.newsshow12=false
      this.newsshowup12=false
      this.newsshowdn12=true
      arr.sort((a,b) => (a.conversion_Rate > b.conversion_Rate) ? 1 : ((b.conversion_Rate > a.conversion_Rate) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow12=false
      this.newsshowup12=true
      this.newsshowdn12=false
      arr.sort((b,a) => (a.conversion_Rate > b.conversion_Rate) ? 1 : ((b.conversion_Rate > a.conversion_Rate) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsConversionRate = isAscending ? false : true;
  }

  sortNewsROI(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    // this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsROI;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.roi==undefined || x.roi==null){
        x.roi=''
      }
    })

    if(currentSort){
      this.newsshow13=false
      this.newsshowup13=false
      this.newsshowdn13=true
      arr.sort((a,b) => (a.roi > b.roi) ? 1 : ((b.roi > a.roi) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow13=false
      this.newsshowup13=true
      this.newsshowdn13=false
      arr.sort((b,a) => (a.roi > b.roi) ? 1 : ((b.roi > a.roi) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsROI = isAscending ? false : true;
  }

  sortNewsComplaint(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    // this.newsshow14=true
    this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsComplaint;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.spam_Complaint==undefined || x.spam_Complaint==null){
        x.spam_Complaint=''
      }
    })

    if(currentSort){
      this.newsshow14=false
      this.newsshowup14=false
      this.newsshowdn14=true
      arr.sort((a,b) => (a.spam_Complaint > b.spam_Complaint) ? 1 : ((b.spam_Complaint > a.spam_Complaint) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow14=false
      this.newsshowup14=true
      this.newsshowdn14=false
      arr.sort((b,a) => (a.spam_Complaint > b.spam_Complaint) ? 1 : ((b.spam_Complaint > a.spam_Complaint) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsComplaint = isAscending ? false : true;
  }

  sortNewsContactList(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    // this.newsshow15=true
    this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsContactList;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.contact_List_Performance==undefined || x.contact_List_Performance==null){
        x.contact_List_Performance=''
      }
    })

    if(currentSort){
      this.newsshow15=false
      this.newsshowup15=false
      this.newsshowdn15=true
      arr.sort((a,b) => (a.contact_List_Performance > b.contact_List_Performance) ? 1 : ((b.contact_List_Performance > a.contact_List_Performance) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow15=false
      this.newsshowup15=true
      this.newsshowdn15=false
      arr.sort((b,a) => (a.contact_List_Performance > b.contact_List_Performance) ? 1 : ((b.contact_List_Performance > a.contact_List_Performance) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsContactList = isAscending ? false : true;
  }

  sortNewsUnsubscribed(arr, isAscending) {

    this.newsshow1=true
    this.newsshow2=true
    this.newsshow3=true
    this.newsshow4=true
    this.newsshow5=true
    this.newsshow6=true
    this.newsshow7=true
    this.newsshow8=true
    this.newsshow9=true
    this.newsshow10=true
    this.newsshow11=true
    this.newsshow12=true
    this.newsshow13=true
    this.newsshow14=true
    this.newsshow15=true
    // this.newsshow16=true

    this.newsshowup1=false
    this.newsshowup2=false
    this.newsshowup3=false
    this.newsshowup4=false
    this.newsshowup5=false
    this.newsshowup6=false
    this.newsshowup7=false
    this.newsshowup8=false
    this.newsshowup9=false
    this.newsshowup10=false
    this.newsshowup11=false
    this.newsshowup12=false
    this.newsshowup13=false
    this.newsshowup14=false
    this.newsshowup15=false
    this.newsshowup16=false

    this.newsshowdn1=false
    this.newsshowdn2=false
    this.newsshowdn3=false
    this.newsshowdn4=false
    this.newsshowdn5=false
    this.newsshowdn6=false
    this.newsshowdn7=false
    this.newsshowdn8=false
    this.newsshowdn9=false
    this.newsshowdn10=false
    this.newsshowdn11=false
    this.newsshowdn12=false
    this.newsshowdn13=false
    this.newsshowdn14=false
    this.newsshowdn15=false
    this.newsshowdn16=false

    var currentSort = this.isAscendingNewsUnsubscribed;
    // let arr = arrval.filter(city => city.sent_To!=null);
    arr.map((x)=>{
      if(x.unsubscribed==undefined || x.unsubscribed==null){
        x.unsubscribed=''
      }
    })

    if(currentSort){
      this.newsshow16=false
      this.newsshowup16=false
      this.newsshowdn16=true
      arr.sort((a,b) => (a.unsubscribed > b.unsubscribed) ? 1 : ((b.unsubscribed > a.unsubscribed) ? -1 : 0));
      this.newsletterReportList=arr
    }else{
      this.newsshow16=false
      this.newsshowup16=true
      this.newsshowdn16=false
      arr.sort((b,a) => (a.unsubscribed > b.unsubscribed) ? 1 : ((b.unsubscribed > a.unsubscribed) ? -1 : 0));
      this.newsletterReportList=arr
    }

    this.isAscendingNewsUnsubscribed = isAscending ? false : true;
  }

  sortArtName(arr, isAscending) {

    // this.artshow1=true
    this.artshow2=true
    this.artshow3=true
    this.artshow4=true
    this.artshow5=true
    this.artshow6=true
    this.artshow7=true
    this.artshow8=true
  
    this.artshowup1=false
    this.artshowup2=false
    this.artshowup3=false
    this.artshowup4=false
    this.artshowup5=false
    this.artshowup6=false
    this.artshowup7=false
    this.artshowup8=false
  
    this.artshowdn1=false
    this.artshowdn2=false
    this.artshowdn3=false
    this.artshowdn4=false
    this.artshowdn5=false
    this.artshowdn6=false
    this.artshowdn7=false
    this.artshowdn8=false
 
  

    var currentSort = this.isAscendinArtName;
    arr.map((x)=>{
      if(x.name==undefined || x.name==null){
        x.name=''
      }
    })

    if(currentSort){
      this.artshow1=false
      this.artshowup1=false
      this.artshowdn1=true
      arr.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      this.articleReportList=arr
    }else{
      this.artshow1=false
      this.artshowup1=true
      this.artshowdn1=false
      arr.sort((b,a) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      this.articleReportList=arr
    }

    this.isAscendinArtName = isAscending ? false : true;
  }

  sortArtNews(arr, isAscending) {

    this.artshow1=true
    // this.artshow2=true
    this.artshow3=true
    this.artshow4=true
    this.artshow5=true
    this.artshow6=true
    this.artshow7=true
    this.artshow8=true
  
    this.artshowup1=false
    this.artshowup2=false
    this.artshowup3=false
    this.artshowup4=false
    this.artshowup5=false
    this.artshowup6=false
    this.artshowup7=false
    this.artshowup8=false
  
    this.artshowdn1=false
    this.artshowdn2=false
    this.artshowdn3=false
    this.artshowdn4=false
    this.artshowdn5=false
    this.artshowdn6=false
    this.artshowdn7=false
    this.artshowdn8=false
 
  

    var currentSort = this.isAscendinArtNews;
    arr.map((x)=>{
      if(x.newsletter==undefined || x.newsletter==null){
        x.newsletter=''
      }
    })

    if(currentSort){
      this.artshow2=false
      this.artshowup2=false
      this.artshowdn2=true
      arr.sort((a,b) => (a.newsletter.toLowerCase() > b.newsletter.toLowerCase()) ? 1 : ((b.newsletter.toLowerCase() > a.newsletter.toLowerCase()) ? -1 : 0));
      this.articleReportList=arr
    }else{
      this.artshow2=false
      this.artshowup2=true
      this.artshowdn2=false
      arr.sort((b,a) => (a.newsletter.toLowerCase() > b.newsletter.toLowerCase()) ? 1 : ((b.newsletter.toLowerCase() > a.newsletter.toLowerCase()) ? -1 : 0));
      this.articleReportList=arr
    }

    this.isAscendinArtNews = isAscending ? false : true;
  }

  sortArticleArray(arrval, isAscending) {

     this.artshow1=true
     this.artshow2=true
    //  this.artshow3=true
     this.artshow4=true
     this.artshow5=true
     this.artshow6=true
     this.artshow7=true
     this.artshow8=true
   
     this.artshowup1=false
     this.artshowup2=false
     this.artshowup3=false
     this.artshowup4=false
     this.artshowup5=false
     this.artshowup6=false
     this.artshowup7=false
     this.artshowup8=false
   
     this.artshowdn1=false
     this.artshowdn2=false
     this.artshowdn3=false
     this.artshowdn4=false
     this.artshowdn5=false
     this.artshowdn6=false
     this.artshowdn7=false
     this.artshowdn8=false
    
    var currentSort = this.isArticleAscending;
    let arr = arrval.filter(city => city.sent_On!=null );
    let arr2 = arrval.filter(city => city.sent_On==null );
   
    if(currentSort){
      this.artshow3=false
      this.artshowup3=false
      this.artshowdn3=true
      arr.sort(function(a, b){
        var aa = a.sent_On.split('/').reverse().join();
         var   bb = b.sent_On.split('/').reverse().join();
        return aa < bb ? -1 : (aa > bb ? 1 : 0);
      });
      let merge=arr2.concat(arr)
      this.articleReportList=merge
    }else{
      this.artshow3=false
      this.artshowup3=true
      this.artshowdn3=false
      arr.sort(function(b, a){
        var aa = a.sent_On.split('/').reverse().join(),
            bb = b.sent_On.split('/').reverse().join();
        return aa < bb ? -1 : (aa > bb ? 1 : 0);
      });
      let merge=arr.concat(arr2)
      this.articleReportList=merge
    }
    
    
    this.isArticleAscending = isAscending ? false : true;
  }

  sortArtClicked(arr, isAscending) {

    this.artshow1=true
    this.artshow2=true
    this.artshow3=true
    // this.artshow4=true
    this.artshow5=true
    this.artshow6=true
    this.artshow7=true
    this.artshow8=true
  
    this.artshowup1=false
    this.artshowup2=false
    this.artshowup3=false
    this.artshowup4=false
    this.artshowup5=false
    this.artshowup6=false
    this.artshowup7=false
    this.artshowup8=false
  
    this.artshowdn1=false
    this.artshowdn2=false
    this.artshowdn3=false
    this.artshowdn4=false
    this.artshowdn5=false
    this.artshowdn6=false
    this.artshowdn7=false
    this.artshowdn8=false
 
  

    var currentSort = this.isAscendinArtClicked;
    arr.map((x)=>{
      if(x.clicked==undefined || x.clicked==null){
        x.clicked=''
      }
    })

    if(currentSort){
      this.artshow4=false
      this.artshowup4=false
      this.artshowdn4=true
      arr.sort((a,b) => (a.clicked > b.clicked) ? 1 : ((b.clicked > a.clicked) ? -1 : 0));
      this.articleReportList=arr
    }else{
      this.artshow4=false
      this.artshowup4=true
      this.artshowdn4=false
      arr.sort((b,a) => (a.clicked > b.clicked) ? 1 : ((b.clicked > a.clicked) ? -1 : 0));
      this.articleReportList=arr
    }

    this.isAscendinArtClicked = isAscending ? false : true;
  }

  sortArtViewed(arr, isAscending) {

    this.artshow1=true
    this.artshow2=true
    this.artshow3=true
    this.artshow4=true
    // this.artshow5=true
    this.artshow6=true
    this.artshow7=true
    this.artshow8=true
  
    this.artshowup1=false
    this.artshowup2=false
    this.artshowup3=false
    this.artshowup4=false
    this.artshowup5=false
    this.artshowup6=false
    this.artshowup7=false
    this.artshowup8=false
  
    this.artshowdn1=false
    this.artshowdn2=false
    this.artshowdn3=false
    this.artshowdn4=false
    this.artshowdn5=false
    this.artshowdn6=false
    this.artshowdn7=false
    this.artshowdn8=false
 
  

    var currentSort = this.isAscendinArtViewed;
    arr.map((x)=>{
      if(x.viewed==undefined || x.viewed==null){
        x.viewed=''
      }
    })

    if(currentSort){
      this.artshow5=false
      this.artshowup5=false
      this.artshowdn5=true
      arr.sort((a,b) => (a.viewed > b.viewed) ? 1 : ((b.viewed > a.viewed) ? -1 : 0));
      this.articleReportList=arr
    }else{
      this.artshow5=false
      this.artshowup5=true
      this.artshowdn5=false
      arr.sort((b,a) => (a.viewed > b.viewed) ? 1 : ((b.viewed > a.viewed) ? -1 : 0));
      this.articleReportList=arr
    }

    this.isAscendinArtViewed = isAscending ? false : true;
  }

  sortArtComments(arr, isAscending) {

    this.artshow1=true
    this.artshow2=true
    this.artshow3=true
    this.artshow4=true
    this.artshow5=true
    // this.artshow6=true
    this.artshow7=true
    this.artshow8=true
  
    this.artshowup1=false
    this.artshowup2=false
    this.artshowup3=false
    this.artshowup4=false
    this.artshowup5=false
    this.artshowup6=false
    this.artshowup7=false
    this.artshowup8=false
  
    this.artshowdn1=false
    this.artshowdn2=false
    this.artshowdn3=false
    this.artshowdn4=false
    this.artshowdn5=false
    this.artshowdn6=false
    this.artshowdn7=false
    this.artshowdn8=false
 
  

    var currentSort = this.isAscendinArtComments;
    arr.map((x)=>{
      if(x.comments==undefined || x.comments==null){
        x.comments=''
      }
    })

    if(currentSort){
      this.artshow6=false
      this.artshowup6=false
      this.artshowdn6=true
      arr.sort((a,b) => (a.comments > b.comments) ? 1 : ((b.comments > a.comments) ? -1 : 0));
      this.articleReportList=arr
    }else{
      this.artshow6=false
      this.artshowup6=true
      this.artshowdn6=false
      arr.sort((b,a) => (a.comments > b.comments) ? 1 : ((b.comments > a.comments) ? -1 : 0));
      this.articleReportList=arr
    }

    this.isAscendinArtComments = isAscending ? false : true;
  }

  sortArtDocument(arr, isAscending) {

    this.artshow1=true
    this.artshow2=true
    this.artshow3=true
    this.artshow4=true
    this.artshow5=true
    this.artshow6=true
    // this.artshow7=true
    this.artshow8=true
  
    this.artshowup1=false
    this.artshowup2=false
    this.artshowup3=false
    this.artshowup4=false
    this.artshowup5=false
    this.artshowup6=false
    this.artshowup7=false
    this.artshowup8=false
  
    this.artshowdn1=false
    this.artshowdn2=false
    this.artshowdn3=false
    this.artshowdn4=false
    this.artshowdn5=false
    this.artshowdn6=false
    this.artshowdn7=false
    this.artshowdn8=false
 
  

    var currentSort = this.isAscendinArtDocument;
    arr.map((x)=>{
      if(x.document_Download==undefined || x.document_Download==null){
        x.document_Download=''
      }
    })

    if(currentSort){
      this.artshow7=false
      this.artshowup7=false
      this.artshowdn7=true
      arr.sort((a,b) => (a.document_Download > b.document_Download) ? 1 : ((b.document_Download > a.document_Download) ? -1 : 0));
      this.articleReportList=arr
    }else{
      this.artshow7=false
      this.artshowup7=true
      this.artshowdn7=false
      arr.sort((b,a) => (a.document_Download > b.document_Download) ? 1 : ((b.document_Download > a.document_Download) ? -1 : 0));
      this.articleReportList=arr
    }

    this.isAscendinArtDocument = isAscending ? false : true;
  }

  sortArtAttached(arr, isAscending) {

    this.artshow1=true
    this.artshow2=true
    this.artshow3=true
    this.artshow4=true
    this.artshow5=true
    this.artshow6=true
    this.artshow7=true
    // this.artshow8=true
  
    this.artshowup1=false
    this.artshowup2=false
    this.artshowup3=false
    this.artshowup4=false
    this.artshowup5=false
    this.artshowup6=false
    this.artshowup7=false
    this.artshowup8=false
  
    this.artshowdn1=false
    this.artshowdn2=false
    this.artshowdn3=false
    this.artshowdn4=false
    this.artshowdn5=false
    this.artshowdn6=false
    this.artshowdn7=false
    this.artshowdn8=false
 
  

    var currentSort = this.isAscendinArtAttached;
    arr.map((x)=>{
      if(x.attached_Document==undefined || x.attached_Document==null){
        x.attached_Document=''
      }
    })

    if(currentSort){
      this.artshow8=false
      this.artshowup8=false
      this.artshowdn8=true
      arr.sort((a,b) => (a.attached_Document > b.attached_Document) ? 1 : ((b.attached_Document > a.attached_Document) ? -1 : 0));
      this.articleReportList=arr
    }else{
      this.artshow8=false
      this.artshowup8=true
      this.artshowdn8=false
      arr.sort((b,a) => (a.attached_Document > b.attached_Document) ? 1 : ((b.attached_Document > a.attached_Document) ? -1 : 0));
      this.articleReportList=arr
    }

    this.isAscendinArtAttached = isAscending ? false : true;
  }

  sortUserName(arr, isAscending) {

    // this.usershow1=true
    this.usershow2=true
    this.usershow3=true
    this.usershow4=true
    this.usershow5=true
    this.usershow6=true
    this.usershow7=true
    this.usershow8=true
    this.usershow9=true
    this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserName;
    arr.map((x)=>{
      if(x.name==undefined || x.name==null){
        x.name=''
      }
    })

    if(currentSort){
      this.usershow1=false
      this.usershowup1=false
      this.usershowdn1=true
      arr.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow1=false
      this.usershowup1=true
      this.usershowdn1=false
      arr.sort((b,a) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      this.userReportList=arr
    }


    this.isAscendinUserName = isAscending ? false : true;
  }

  sortUserEmail(arr, isAscending) {

    this.usershow1=true
    // this.usershow2=true
    this.usershow3=true
    this.usershow4=true
    this.usershow5=true
    this.usershow6=true
    this.usershow7=true
    this.usershow8=true
    this.usershow9=true
    this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserEmail;
    arr.map((x)=>{
      if(x.email==undefined || x.email==null){
        x.email=''
      }
    })

    if(currentSort){
      this.usershow2=false
      this.usershowup2=false
      this.usershowdn2=true
      arr.sort((a,b) => (a.email.toLowerCase() > b.email.toLowerCase()) ? 1 : ((b.email.toLowerCase() > a.email.toLowerCase()) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow2=false
      this.usershowup2=true
      this.usershowdn2=false
      arr.sort((b,a) => (a.email.toLowerCase() > b.email.toLowerCase()) ? 1 : ((b.email.toLowerCase() > a.email.toLowerCase()) ? -1 : 0));
      this.userReportList=arr
    }

    this.isAscendinUserEmail = isAscending ? false : true;
  }

  sortUserNews(arr, isAscending) {

    this.usershow1=true
    this.usershow2=true
    this.usershow3=true
    // this.usershow4=true
    this.usershow5=true
    this.usershow6=true
    this.usershow7=true
    this.usershow8=true
    this.usershow9=true
    this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserNews;
    arr.map((x)=>{
      if(x.newsletters==undefined || x.newsletters==null){
        x.newsletters=''
      }
    })

    if(currentSort){
      this.usershow4=false
      this.usershowup4=false
      this.usershowdn4=true
      arr.sort((a,b) => (a.newsletters > b.newsletters) ? 1 : ((b.newsletters > a.newsletters) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow4=false
      this.usershowup4=true
      this.usershowdn4=false
      arr.sort((b,a) => (a.newsletters > b.newsletters) ? 1 : ((b.newsletters > a.newsletters) ? -1 : 0));
      this.userReportList=arr
    }

    this.isAscendinUserNews = isAscending ? false : true;
  }

  sortUserArts(arr, isAscending) {

    this.usershow1=true
    this.usershow2=true
    this.usershow3=true
    this.usershow4=true
    // this.usershow5=true
    this.usershow6=true
    this.usershow7=true
    this.usershow8=true
    this.usershow9=true
    this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserArts;
    arr.map((x)=>{
      if(x.article==undefined || x.article==null){
        x.article=''
      }
    })

    if(currentSort){
      this.usershow5=false
      this.usershowup5=false
      this.usershowdn5=true
      arr.sort((a,b) => (a.article > b.article) ? 1 : ((b.article > a.article) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow5=false
      this.usershowup5=true
      this.usershowdn5=false
      arr.sort((b,a) => (a.article > b.article) ? 1 : ((b.article > a.article) ? -1 : 0));
      this.userReportList=arr
    }

    this.isAscendinUserArts = isAscending ? false : true;
  }

  sortUserClicked(arr, isAscending) {

    this.usershow1=true
    this.usershow2=true
    this.usershow3=true
    this.usershow4=true
    this.usershow5=true
    // this.usershow6=true
    this.usershow7=true
    this.usershow8=true
    this.usershow9=true
    this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserClicked;
    arr.map((x)=>{
      if(x.clicked==undefined || x.clicked==null){
        x.clicked=''
      }
    })

    if(currentSort){
      this.usershow6=false
      this.usershowup6=false
      this.usershowdn6=true
      arr.sort((a,b) => (a.clicked > b.clicked) ? 1 : ((b.clicked > a.clicked) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow6=false
      this.usershowup6=true
      this.usershowdn6=false
      arr.sort((b,a) => (a.clicked > b.clicked) ? 1 : ((b.clicked > a.clicked) ? -1 : 0));
      this.userReportList=arr
    }

    this.isAscendinUserClicked = isAscending ? false : true;
  }

  sortUserLogged(arr, isAscending) {

    this.usershow1=true
    this.usershow2=true
    this.usershow3=true
    this.usershow4=true
    this.usershow5=true
    this.usershow6=true
    // this.usershow7=true
    this.usershow8=true
    this.usershow9=true
    this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserLogged;
    arr.map((x)=>{
      if(x.logged_in==undefined || x.logged_in==null){
        x.logged_in=''
      }
    })

    if(currentSort){
      this.usershow7=false
      this.usershowup7=false
      this.usershowdn7=true
      arr.sort((a,b) => (a.logged_in > b.logged_in) ? 1 : ((b.logged_in > a.logged_in) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow7=false
      this.usershowup7=true
      this.usershowdn7=false
      arr.sort((b,a) => (a.logged_in > b.logged_in) ? 1 : ((b.logged_in > a.logged_in) ? -1 : 0));
      this.userReportList=arr
    }

    this.isAscendinUserLogged = isAscending ? false : true;
  }

  sortUserLeft(arr, isAscending) {

    this.usershow1=true
    this.usershow2=true
    this.usershow3=true
    this.usershow4=true
    this.usershow5=true
    this.usershow6=true
    this.usershow7=true
    // this.usershow8=true
    this.usershow9=true
    this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserLeft;
    arr.map((x)=>{
      if(x.left==undefined || x.left==null){
        x.left=''
      }
    })

    if(currentSort){
      this.usershow8=false
      this.usershowup8=false
      this.usershowdn8=true
      arr.sort((a,b) => (a.left > b.left) ? 1 : ((b.left > a.left) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow8=false
      this.usershowup8=true
      this.usershowdn8=false
      arr.sort((b,a) => (a.left > b.left) ? 1 : ((b.left > a.left) ? -1 : 0));
      this.userReportList=arr
    }

    this.isAscendinUserLeft = isAscending ? false : true;
  }

  sortUserComments(arr, isAscending) {

    this.usershow1=true
    this.usershow2=true
    this.usershow3=true
    this.usershow4=true
    this.usershow5=true
    this.usershow6=true
    this.usershow7=true
    this.usershow8=true
    // this.usershow9=true
    this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserComments;
    arr.map((x)=>{
      if(x.comments==undefined || x.comments==null){
        x.comments=''
      }
    })

    if(currentSort){
      this.usershow9=false
      this.usershowup9=false
      this.usershowdn9=true
      arr.sort((a,b) => (a.comments > b.comments) ? 1 : ((b.comments > a.comments) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow9=false
      this.usershowup9=true
      this.usershowdn9=false
      arr.sort((b,a) => (a.comments > b.comments) ? 1 : ((b.comments > a.comments) ? -1 : 0));
      this.userReportList=arr
    }

    this.isAscendinUserComments = isAscending ? false : true;
  }

  sortUserSessions(arr, isAscending) {

    this.usershow1=true
    this.usershow2=true
    this.usershow3=true
    this.usershow4=true
    this.usershow5=true
    this.usershow6=true
    this.usershow7=true
    this.usershow8=true
    this.usershow9=true
    // this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserSessions;
    arr.map((x)=>{
      if(x.sessions==undefined || x.sessions==null){
        x.sessions=''
      }
    })

    if(currentSort){
      this.usershow10=false
      this.usershowup10=false
      this.usershowdn10=true
      arr.sort((a,b) => (a.sessions > b.sessions) ? 1 : ((b.sessions > a.sessions) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow10=false
      this.usershowup10=true
      this.usershowdn10=false
      arr.sort((b,a) => (a.sessions > b.sessions) ? 1 : ((b.sessions > a.sessions) ? -1 : 0));
      this.userReportList=arr
    }

    this.isAscendinUserSessions = isAscending ? false : true;
  }

  sortUserCountry(arr,isAscending){

    this.usershow1=true
    this.usershow2=true
    // this.usershow3=true
    this.usershow4=true
    this.usershow5=true
    this.usershow6=true
    this.usershow7=true
    this.usershow8=true
    this.usershow9=true
    this.usershow10=true
  
    this.usershowup1=false
    this.usershowup2=false
    this.usershowup3=false
    this.usershowup4=false
    this.usershowup5=false
    this.usershowup6=false
    this.usershowup7=false
    this.usershowup8=false
    this.usershowup9=false
    this.usershowup10=false
  
    this.usershowdn1=false
    this.usershowdn2=false
    this.usershowdn3=false
    this.usershowdn4=false
    this.usershowdn5=false
    this.usershowdn6=false
    this.usershowdn7=false
    this.usershowdn8=false
    this.usershowdn9=false
    this.usershowdn10=false
 
  

    var currentSort = this.isAscendinUserCountry;
    arr.map((x)=>{
      if(x.country==undefined || x.country==null){
        x.country=''
      }
    })

    if(currentSort){
      this.usershow3=false
      this.usershowup3=false
      this.usershowdn3=true
      arr.sort((a,b) => (a.country > b.country) ? 1 : ((b.country > a.country) ? -1 : 0));
      this.userReportList=arr
    }else{
      this.usershow3=false
      this.usershowup3=true
      this.usershowdn3=false
      arr.sort((b,a) => (a.country > b.country) ? 1 : ((b.country > a.country) ? -1 : 0));
      this.userReportList=arr
    }

    this.isAscendinUserCountry = isAscending ? false : true;
  }
}
